import ConfirmNewUsers from "../../team/ModalScreens/ConfirmNewUsers";
import StepWrapper from "../StepWrapper";

export default function TeamConfirmStep({
  newUsers,
  existingUsers,
  deactivatedUsers,
  setUsersState,
  updateUsersAndBillingText,
  hasBillingSetup,
  orgIsManualBilling,
  error,
  billingIncrementText,
}) {
  const emptyTeam =
    newUsers.length === 0 &&
    existingUsers.length === 0 &&
    deactivatedUsers.length === 0;

  const descriptionText = emptyTeam
    ? "If you had invited any team members, you would have been able to assign roles and account types to them here."
    : "Assign roles and account types to your team members. You can always change these later from your team settings.";

  return (
    <StepWrapper
      title="Set Roles and Permissions"
      description={descriptionText}
    >
      <ConfirmNewUsers
        newUsers={newUsers}
        existingUsers={existingUsers}
        deactivatedUsers={deactivatedUsers}
        setUsersState={setUsersState}
        updateUsersAndBillingText={updateUsersAndBillingText}
        isPartOfOrganization={false}
        hasBillingSetup={hasBillingSetup}
        orgIsManualBilling={orgIsManualBilling}
        error={error}
        billingIncrementText={billingIncrementText}
        onboardingMode={true}
      />
    </StepWrapper>
  );
}
